export default "__VITE_ASSET__6970989e__"